<agpr-dialog-container
    [id]="id"
    class="agpr-targetingBatchActionsDialog"
    [heading]="'Discover.batchActions.header'"
    (close)="cancel()"
>


    <agpr-scroll-panel
        class="agpr-targetingBatchActionsDialog-content"
        [agprLoading]="loading"
    >
        <agpr-panel
            header="Discover.batchActions.chooseAction"
            [contentPadding]="false"
            [toggleable]="false"
            [isFormGroup]="true"
            [noBorder]="true"
            [paddingBottom]="0"
        >
            <agpr-dropdown
                [id]="id + '_batchActionOptions'"
                [options]="batchActionOptions"
                ariaLabel="Discover.batchActions.chooseAction"
                [(ngModel)]="selectedBatchAction"
                (ngModelChange)="batchActionChanged()"
            >
            </agpr-dropdown>
            <div class="agpr-targetingBatchActionsDialog-listSelector">
                <agpr-autocomplete-chips
                    [id]="id + '_listSelector'"
                    *ngIf="
                        selectedBatchAction?.value ===
                            batchActionsEnum.addToList ||
                        selectedBatchAction?.value ===
                            batchActionsEnum.removeFromList
                    "
                    field="name"
                    placeholder="Discover.batchActions.listAutocomplete.placeholder"
                    [(ngModel)]="selectedLists"
                    [header]="listSelectorHeader"
                    [autocompleteOptions]="autocompleteOptions"
                    [ariaLabel]="listSelectorHeader | localize"
                    [required]="true"
                    [showHiddenOption]="true"
                ></agpr-autocomplete-chips>
            </div>
            <ng-container
                *ngIf="
                    selectedBatchAction.value === batchActionsEnum.distribute
                "
            >
                <div class="targetingBatchActionsDialog-listSelector-options">
                    <agpr-radio
                        [id]="id + '_createNewDistro.radio'"
                        [value]="false"
                        label="Discover.batchActions.distribute.createNewDistribution"
                        hiddenLabel="Discover.batchActions.distribute.createNewDistribution"
                        [(ngModel)]="useExistingDistro"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="id + '_useExistingDistro.radio'"
                        [value]="true"
                        label="Discover.batchActions.distribute.useExistingDistribution"
                        hiddenLabel="Discover.batchActions.distribute.useExistingDistribution"
                        [(ngModel)]="useExistingDistro"
                    ></agpr-radio>
                </div>
                <div
                    class="agpr-targetingBatchActionsDialog-listSelector"
                    *ngIf="useExistingDistro"
                >
                    <agpr-dropdown
                        [id]="id + '_distributions'"
                        [options]="distributionDrafts"
                        placeholder="Discover.batchActions.distribute.distributionDropdown.placeholder"
                        ariaLabel="Discover.batchActions.distribute.distributionDropdown.placeholder"
                        [(ngModel)]="selectedDistribution"
                        [showHiddenOption]="true"
                    ></agpr-dropdown>
                </div>
            </ng-container>
        </agpr-panel>
        <agpr-panel
            [header]="'Discover.batchActions.chooseContactsOrOutlets'"
            [contentPadding]="false"
            [toggleable]="false"
            [isFormGroup]="true"
            role="radiogroup"
            [noBorder]="true"
            [paddingBottom]="0"
        >
            <agpr-radio
                [id]="id + '_selectedContactsRadio'"
                [(ngModel)]="sourceMode"
                (ngModelChange)="sourceModeChanged()"
                [value]="sourceModes.currentlySelectedContacts"
                name="contact_selection"
                [disabled]="
                    !_selectedEntities || _selectedEntities.length === 0
                "
                [label]="
                    entityMode === entityTypeEnum.CONTACT
                        ? 'Discover.batchActions.currentlySelectedContacts'
                        : 'Discover.batchActions.currentlySelectedOutlets'
                "
                [hiddenLabel]="
                    entityMode === entityTypeEnum.CONTACT
                        ? 'Discover.batchActions.currentlySelectedContacts'
                        : 'Discover.batchActions.currentlySelectedOutlets'
                "
            >
            </agpr-radio>
            <agpr-radio
                [id]="id + '_contactsFromRadio'"
                [(ngModel)]="sourceMode"
                (ngModelChange)="sourceModeChanged()"
                [value]="sourceModes.contactsFrom"
                name="contact_selection"
                [label]="'Discover.batchActions.contactsOrOutletsFrom'"
                [hiddenLabel]="'Discover.batchActions.contactsOrOutletsFrom'"
                class="agpr-saveStylesDialog-radio"
            >
            </agpr-radio>
            <div
                class="agpr-targetingBatchActionsDialog-sourcePicker agpr-contextMenu-parent"
                *ngIf="sourceMode === sourceModes.contactsFrom"
            >

                @let disabledViewSourceMessage = unSupportedViewSourceTypes.includes(selectedSourceType?.value)
                ? 'Monitoring.sourcePickerField.viewSource.tooltip.unableToView'
                : 'Monitoring.sourcePickerField.header.viewSource';

                <div class="agpr-contextMenu top right">
                    <agpr-button
                        icon="fa-regular fa-duotone fa-eye"
                        [tooltip]="disabledViewSourceMessage"
                        tooltipPosition="left"
                        (click)="viewSource($event)"
                        [disabled]="disabledViewSourceButton"
                        [style]="buttonTypes.contextMenu">
                    </agpr-button>
                </div>

                <div class="agpr-targetingBatchActionsDialog-sourcePicker-heading">
                    <div class="agpr-targetingBatchActionsDialog-sourcePicker-heading-dateRangeLabel">
                        {{ 'Source' | localize }}
                    </div>
                </div>

                <div
                    class="agpr-targetingBatchActionsDialog-sourcePicker-dropdown-container"
                >
                    <agpr-dropdown
                        [id]="id + '_sourcePicker_sourceTypes'"
                        class="agpr-targetingBatchActionsDialog-sourcePicker-dropdown left"
                        [options]="sourceTypes"
                        [(ngModel)]="selectedSourceType"
                        (ngModelChange)="sourceTypeChanged()"
                        ariaLabel="Discover.batchActions.selectSourceType"
                    ></agpr-dropdown>
                    <agpr-dropdown
                        [id]="id + '_sourcePicker_sources'"
                        class="agpr-targetingBatchActionsDialog-sourcePicker-dropdown right"
                        ariaLabel="Discover.batchActions.selectSource"
                        [allowNull]="true"
                        [options]="sources"
                        [(ngModel)]="selectedSource"
                        (ngModelChange)="sourceChanged()"
                        [disabled]="
                            selectedSourceType?.value ===
                                sourceTypeEnums.allPrivateContacts ||
                            selectedSourceType?.value ===
                                sourceTypeEnums.allInteractions
                        "
                        [showHiddenOption]="true"
                    >
                    </agpr-dropdown>
                    <agpr-filter-dropdown
                        class="agpr-targetingBatchActionsDialog-sourcePicker-dropdown-filter"
                        [id]="id + '_sourceFilter'"
                        [disabled]="
                            !selectedSource &&
                            selectedSourceType?.value !==
                                sourceTypeEnums.allPrivateContacts &&
                            selectedSourceType?.value !==
                                sourceTypeEnums.allInteractions
                        "
                        [ariaDescribedBy]="id + '_sourceFilter_chips'"
                    >
                    </agpr-filter-dropdown>
                </div>
                <div
                    class="agpr-targetingBatchActionsDialog-sourcePicker-chips-container"
                >
                    <agpr-filter-chips
                        [id]="id + '_sourceFilter_chips'"
                    ></agpr-filter-chips>
                </div>
            </div>

            <div class="agpr-targetingBatchActionsDialog-message">
                @if (selectedSourceType?.value ===
                sourceTypeEnums.allInteractions && !previewCountLoading) {
                <agpr-message [severity]="messageSeverities.info">
                    {{
                        "Discover.batchActions.interactionExport.count.preview"
                            | localize
                                : {
                                      contactCount: contactCount,
                                      outletCount: outletCount
                                  }
                    }}
                </agpr-message>
                } @else {
                <agpr-message
                    *ngIf="
                        previewCount !== null &&
                        (previewCount <= csvExportLimit ||
                            selectedBatchAction.value !==
                                batchActionsEnum.export)
                    "
                    [severity]="
                        previewCount > 0
                            ? messageSeverities.info
                            : messageSeverities.warning
                    "
                >
                    {{
                        "Discover.batchActions.contactsOutletsSelected"
                            | localize : { count: previewCount }
                    }}
                </agpr-message>
                <agpr-message
                    *ngIf="
                        previewCount > csvExportLimit &&
                        selectedBatchAction.value === batchActionsEnum.export
                    "
                    [severity]="messageSeverities.warning"
                >
                    <div>
                        <b>{{
                            (entityMode === entityTypeEnum.CONTACT
                                ? "Discover.batchActions.export.overLimit"
                                : "Discover.batchActions.export.overLimit.outlet"
                            ) | localize
                        }}</b>
                    </div>
                    {{
                        (entityMode === entityTypeEnum.CONTACT
                            ? "Discover.batchActions.export.overLimit.details"
                            : "Discover.batchActions.export.overLimit.details.outlet"
                        )
                            | localize
                                : {
                                      count: previewCount,
                                      limit: csvExportLimit
                                  }
                    }}
                </agpr-message>
                }
            </div>
        </agpr-panel>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_confirmDialog_cancel'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="selectedBatchAction.value === batchActionsEnum.export"
            [id]="id + '_confirmDialog_export'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.next"
            [disabled]="previewCount <= 0 || previewCount > csvExportLimit"
            (click)="exportContacts()"
        ></agpr-button>
        <agpr-button
            *ngIf="
                selectedBatchAction.value ===
                batchActionsEnum.exportInteractions
            "
            [id]="id + '_confirmDialog_exportInteractions'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.next"
            [disabled]="previewCount <= 0"
            (click)="exportInteractions()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedBatchAction.value === batchActionsEnum.addToList"
            [id]="id + '_button_addToList'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.addToList.buttonLabel"
            [disabled]="previewCount <= 0 || selectedLists.length <= 0"
            [ariaDescribedBy]="id + '_button_addToList_disabledMessage'"
            [tooltip]="'Discover.batchActions.listRequired'"
            (click)="confirmAddToList()"
        ></agpr-button>
        <agpr-button
            *ngIf="
                selectedBatchAction.value === batchActionsEnum.removeFromList
            "
            [id]="id + '_button_removeFromList'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.removeFromList.buttonLabel"
            [ariaLabel]="'Discover.batchActions.removeFromList.buttonLabel'"
            [disabled]="previewCount <= 0 || selectedLists.length <= 0"
            [ariaDescribedBy]="id + '_button_addToList_disabledMessage'"
            [tooltip]="'Discover.batchActions.listRequired'"
            (click)="confirmRemoveFromList()"
        ></agpr-button>
        <span
            [id]="id + '_button_addToList_disabledMessage'"
            class="u-srOnly"
            *ngIf="selectedLists.length <= 0"
        >
            {{ "Discover.batchActions.listRequired" | localize }}
        </span>
        <agpr-button
            *ngIf="selectedBatchAction.value === batchActionsEnum.distribute"
            [id]="id + '_button_distribute'"
            [style]="buttonTypes.primary"
            [label]="
                useExistingDistro
                    ? 'Discover.batchActions.distribute.addRecipients'
                    : 'Discover.batchActions.distribute.createNewDistribution'
            "
            [disabled]="
                previewCount <= 0 ||
                (useExistingDistro && !selectedDistribution)
            "
            [ariaDescribedBy]="id + '_button_addRecipient_disabledMessage'"
            [tooltip]="'Discover.batchActions.distributionRequired'"
            (click)="addToListAndGotoDistribution()"
        ></agpr-button>
        <span
            [id]="id + '_button_addRecipient_disabledMessage'"
            class="u-srOnly"
            *ngIf="useExistingDistro && !selectedDistribution"
        >
            {{ "Discover.batchActions.distributionRequired" | localize }}
        </span>
    </ng-template>
</agpr-dialog-container>
